module.exports = __webpack_public_path__ + "img/sOceanChes_350x350.5d110962.jpg";